import { ReduxStateHandler } from '../ReduxStateHandler';
import { STATE_CATEGORY } from '../registry';

export const RESULTS_TAB = {
  LIST: 'LIST',
  MAP: 'MAP',
};

export const ResultsTabStateHandler = new ReduxStateHandler({
  actionName: 'ui/UPDATE_RESULTS_TAB',
  statePath: 'resultsTab',
  category: STATE_CATEGORY.UI,
  initialState: RESULTS_TAB.LIST,
});

export const HighlightedResultStateHandler = new ReduxStateHandler({
  actionName: 'ui/UPDATE_HIGHLIGHTED_RESULT_INDEX',
  statePath: 'highlightedResultIndex',
  category: STATE_CATEGORY.UI,
  initialState: null,
});
